<template>
  <svg width="58" height="52" viewBox="0 0 58 52" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="32.1015" cy="26" r="25" fill="#ba3b46" />
    <circle opacity="0.5" cx="16.0961" cy="16.691" r="12.5" transform="rotate(-4 16.0961 16.691)" fill="#F4EAD3" />
    <path
      d="M9.01674 10.6177C9.17829 10.3986 9.10898 10.0398 8.91852 9.84537C8.68044 9.60229 8.37605 9.67552 8.21812 9.94629C5.67316 14.0201 6.078 19.8097 9.20917 23.4866C9.40325 23.7328 9.75526 23.7082 9.9168 23.4891C10.0783 23.27 10.053 22.9082 9.90658 22.7106C7.11234 19.4257 6.75448 14.3081 9.01674 10.6177Z"
      fill="#2B2B2B"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M30.913 25.8636L42.7698 35.1582C43.5872 35.8205 44.0644 36.7636 44.1323 37.7352C44.1967 38.6557 43.903 39.6013 43.2844 40.3126C41.9521 41.8447 39.5953 41.9581 38.1068 40.5205L27.2969 30.0221L26.0309 28.8259C20.485 33.3248 12.3629 33.3275 6.78008 28.4761C0.540504 23.054 -0.124636 13.5421 5.29961 7.30439C10.7239 1.06669 20.2391 0.401316 26.4787 5.82341C32.0103 10.6783 33.1892 18.7154 29.5043 24.8315L30.913 25.8636ZM8.48943 26.4552C13.6343 30.926 21.4614 30.3787 25.934 25.2354C30.4066 20.092 29.8595 12.2676 24.7146 7.79679C19.5697 3.32594 11.7426 3.87326 7.27 9.01663C2.79738 14.16 3.34451 21.9844 8.48943 26.4552Z"
      fill="#2B2B2B"
    />
  </svg>
</template>

<script>
export default {
  name: 'RateLimitSvg'
}
</script>

<style></style>
